var map = {
	"./en/translation.json": [
		981,
		1
	],
	"./package.json": [
		982,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 777;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locales lazy ^\.\/.*\.json$
// module id = 777
// module chunks = 2